/** @format */
import { SearchFacet } from '@toucan/common/services/search/constants';
import { Facet, FilterQuery } from '@toucan/common/services/search/types';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface FilterOption {
    /**
     * The label to show
     */
    label: string;

    /**
     * The value of the filter
     */
    value: string | number;

    /**
     * The number of products under that filter
     */
    quantity?: number;
    disabled?: boolean;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface Filter {
    /**
     * Display label of the filter
     */
    label: string;

    /**
     * An id for the filter
     */
    id: SearchFacet;

    /**
     * The filters
     */
    options: FilterOption[];

    /**
     * Currently Selected Filter Options
     */
    selectedOptions: FilterOption[];

    selectedVariant?: string;

    /**
     * Should this filter display quantities?
     */
    displayOptionQuantity?: boolean;
    baseFilterQuery: FilterQuery;
    getAllOptions: () => Promise<string[]>;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface ConditionQueryResponse {
    facets: Facet[];
}

export enum SortDirection {
    ASC = 'ASC',
    DESC = 'DESC',
}
// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface SortByOption {
    /**
     * Display text for the sort option
     */
    title: string;

    /**
     * The value of the sort option
     */
    value: string;

    /**
     * The facet that this sort option should be applied to
     */
    facet: string;

    /**
     * The direction in which to return the results, one of:
     * 1. ASC,
     * 2. DESC
     */
    direction: SortDirection;
}
